export const throttle = (method, delay, duration) => {
    let timer = null;
    let begin = null;
    return function () {
        const context = this;
        const args = arguments;
        const current = new Date();
        if (!begin) {
            begin = current;
        }
        if (timer) {
            window.clearTimeout(timer);
        }
        if (duration && current - begin >= duration) {
            method.apply(context, args);
            begin = null;
        }
        else {
            timer = window.setTimeout(() => {
                method.apply(context, args);
                begin = null;
            }, delay);
        }
    };
};
export function isDef(o) {
    return o !== null && o !== undefined;
}
const wetvLsKey = 'vsite_usercenter_ls_';
const getLsKey = key => wetvLsKey + key;
export const ls = new class {
    set(key, data, raw = false) {
        try {
            // console.time()
            localStorage.setItem(getLsKey(key), raw ? data : JSON.stringify(data));
            // console.timeEnd()
        }
        catch (error) {
            console.log('ls error:', error);
        }
    }
    get(key, raw = false) {
        try {
            const str = localStorage.getItem(getLsKey(key));
            return raw ? str : JSON.parse(str);
        }
        catch (error) {
            console.log('ls error:', error);
        }
    }
}();
export function str2Js(strJson) {
    if (typeof strJson === 'string') {
        try {
            return JSON.parse(strJson);
        }
        catch (error) {
            console.error(error);
            return {};
        }
    }
    else {
        console.error(`${strJson} is not a json string`);
        return {};
    }
}
export function removeHttp(url) {
    var _a;
    return ((_a = url) === null || _a === void 0 ? void 0 : _a.replace(/^http:/, '')) || '';
}
export function remove(array, target) {
    const index = this.todos.indexOf(target);
    array.splice(index, 1);
}
